export const SEND_SIGNIN_EMAIL = "SEND_SIGNIN_EMAIL";
export const SIGNIN_EMAIL_SENT = "SIGNIN_EMAIL_SENT";
export const AUTH_CHANGE = "AUTH_CHANGE";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const SET_HAS_PREVIOUS_ATTEMPTS = "SET_HAS_PREVIOUS_ATTEMPTS";
export const LOGOUT = "LOGOUT";
export const ERROR = "ERROR";
